import React, { FC, useState } from 'react';

import { LayoutChangeEvent } from 'react-native';

import { ProductPriceCalories } from 'pages/menu/components/product-detail/product-price-calories';
import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { useScrollResetOnMount } from 'state/scroll/hooks/use-scroll-reset-on-mount';

import { CurvedBackground } from './curved-bg';
import {
  ProductImage,
  ProductImageContainer,
  ProductInformationContainer,
  ProductOverviewContainer,
  ProductTitle,
} from './styled';

interface ProductOverviewProps {
  productTitle?: string;
}

export const ProductOverview: FC<ProductOverviewProps> = props => {
  const { selectedProductImage } = useProductWizardContext();
  const [bgHeight, setBgHeight] = useState(0);

  useScrollResetOnMount();

  return (
    <ProductOverviewContainer withSpacing={!!props.productTitle}>
      {props.productTitle ? (
        <ProductTitle>{props.productTitle}</ProductTitle>
      ) : (
        <ProductImageContainer>
          <CurvedBackground height={bgHeight} />
          <ProductImage
            image={selectedProductImage}
            alt={selectedProductImage.locale?.imageDescription ?? ''}
            onLayout={({ nativeEvent }: LayoutChangeEvent) => {
              const { height } = nativeEvent.layout;
              const bgHeight = height - height * 0.4;
              setBgHeight(bgHeight);
            }}
          />
        </ProductImageContainer>
      )}

      <ProductInformationContainer>
        <ProductPriceCalories />
      </ProductInformationContainer>
    </ProductOverviewContainer>
  );
};
